<template>
  <div>
    <SmartTitle
      weight="medium"
      class="main-title"
    >
      Parametrizar Metas
    </SmartTitle>
    <div class="flex my-4 justify-between">
      <SmartSearch class="main-search">
        <v-text-field
          v-model="search"
          @keyup="searchGoalDistribution"
          append-icon="search"
          placeholder="Pesquisar..."
          single-line
          hide-details
          class="search"
        />
      </SmartSearch>
      <div>
        <SmartButton
          class="ml-4"
          @click="showDrawerAdd = true"
        >
          Adicionar Parametrização
        </SmartButton>
      </div>
    </div>
    <div v-if="!loading" class="main-section">
      <v-data-table
        :headers="headers"
        :items="distributionList"
        class="my-4"
        no-data-text="Não há dados a serem exibidos"
        hide-actions
      >
        <template v-slot:items="props">
          <td class="force-text-black">{{ props.item.role_name }}</td>
          <td class="products-style" :title="props.item.segment_name" style="max-width: 250px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ props.item.segment_name }}</td>
          <td>{{ props.item.factor }}%</td>
          <td class="view-icon">
            <label
              @click="load(props.item.id)"
              class="ml-2 cursor-pointer"
            >
              <SmartIcon
                :size="2"
                name="edit"
                class="mx-1"
              />
            </label>
          </td>
          <td class="view-icon">
            <label
              @click="parametrizationDelete(props.item.id)"
              class="ml-3 cursor-pointer"
            >
              <SmartIcon
                :size="2"
                name="trash"
                class="mr-1-2"
              />
            </label>
          </td>
        </template>
      </v-data-table>
      <div class="flex justify-center">
        <v-pagination
          v-model="pagination"
          :length="goalDistribuitionList.last_page"
          :value="goalDistribuitionList.current_page"
          :total-visible="7"
          circle
        />
      </div>
    </div>
    <SmartCard class="mt-1 p-3" v-else>
      <SmartSkeletonLoading
        :items="10"
        :height="4"
      />
    </SmartCard>
    <div>
      <SmartDrawer
        @close="() => {showDrawer = false}"
        :show="showDrawer"
      >
        <template v-slot:header>
          <SmartTitle
            class="text-black"
            weight="regular"
          >
            Consultores de Venda
          </SmartTitle>
        </template>
        <template v-slot:headerSecondary>
          <SmartTitle
            class="ml-4 text-black"
            heading="3"
            weight="regular"
          >
            Atualizar parametrização de distribuição de metas CVS
          </SmartTitle>
        </template>
        <InfoParameterization v-if="infoDistribution" :distribution="infoDistribution" @close="closeEdit()" />
      </SmartDrawer>
    </div>
    <div>
      <SmartDrawer
        @close="() => {showDrawerAdd = false}"
        :show="showDrawerAdd"
      >
        <template v-slot:header>
          <SmartTitle
            class="text-black"
            weight="regular"
          >
            Adicionar Parametrização
          </SmartTitle>
        </template>
        <template v-slot:headerSecondary>
          <SmartTitle
            class="ml-4 text-black"
            heading="3"
            weight="regular"
          >
            Adicionar parametrização de distribuição de metas CVs
          </SmartTitle>
        </template>
        <InfoParameterizationAdd @close="close()" :page="pagination"  />
      </SmartDrawer>
      <SmartModal
        v-if="modal"
        v-bind="modal"
        @close.prevent="modal = null"
        @return="deleteParameterization"
      >
        {{ modal.text }}
      </SmartModal>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    InfoParameterization: () => import('./InfoParameterization'),
    InfoParameterizationAdd: () => import('./InfoParameterizationAdd'),
    SmartSearch: () => import('../../../../packages/SmartSearch/index')
  },
  name: 'goalsDistribuitionComponent',

  data() {
    return {
      distributor: null,
      loading: false,
      rolesToSelect: [],
      search: '',
      modal: null,
      roles: [],
      id: '',
      showDrawer: false,
      showDrawerAdd: false,
      infoDistribution: null,
      pagination: 1,
      headers: [
        { text: 'Cargo', value: 'cargo', sortable: false },
        { text: 'Produto', value: 'produto', sortable: false },
        { text: 'Fator', value: 'fator', sortable: false },
        { text: 'Editar', value: 'editar', sortable: false },
        { text: 'Excluir', value: 'excluir', sortable: false }
      ],
      distribuition: []

    };
  },
  methods: {
    ...mapActions({
      fetchListAction: 'goalsDistribuition/fetchList',
      loadDistribution: 'goalsDistribuition/fetchDistributionById',
      delete: 'goalsDistribuition/delete'
    }),
    async searchGoalDistribution() {
      this.loading = true;
      if (!this.search) await this.fetchListAction({ page: this.pagination, search: '' });
      else await this.fetchListAction({ page: this.pagination, search: this.search });
      this.loading = false;
    },
    showSuccessModal() {
      this.modal = {
        type: 'success',
        title: 'Tudo Certo!',
        icon: 'accepted',
        buttonText: 'Ok',
        text: 'Ajustes na parametrização realizados com sucesso.'
      };
    },
    showSuccessModalDelete() {
      this.modal = {
        type: 'success',
        title: 'Tudo Certo!',
        icon: 'accepted',
        buttonText: 'Ok',
        text: 'Exclusão realizada com sucesso!'
      };
    },
    showErrorModal() {
      this.modal = {
        type: 'warning',
        title: 'Ops!',
        icon: 'alert',
        buttonText: 'Ok',
        text: 'Ops! Erro desconhecido...',
        routerRedirect: 'Parametrizacao'
      };
    },
    parametrizationDelete(id) {
      this.id = id;
      this.showDeleteModal();
    },
    deleteParameterization() {
      this.delete(this.id).then(() => {
        this.fetchList();
        this.showSuccessModalDelete();
      })
        .catch((response) => {
          this.showErrorModal({ response });
        });
    },
    showDeleteModal() {
      this.modal = {
        type: 'warning',
        title: 'Ops! Vamos com calma...',
        icon: 'alert',
        buttonText: 'Cancelar',
        secondButton: 'Ok, excluir',
        text: 'Deseja realmente excluir este item?'
      };
    },
    close() {
      this.showDrawerAdd = false;
    },
    closeEdit() {
      this.showDrawer = false;
    },
    showDrawerEdit(id) {
      const vm = this;
      this.loadDistribution(id).then((data) => {
        vm.infoId = data.data.id;
      });
      this.showDrawer = true;
    },
    load(id) {
      this.infoDistribution = null;
      this.loadDistribution(id).then((response) => {
        let segments = response.data[0].segments;
        segments.id = segments.id.split(',').map(segment => segment.trim() * 1);
        segments.name = segments.name.split(',').map(segment => segment.trim());
        response.data[0].segments = segments;
        this.infoDistribution = response.data[0];
      });

      this.showDrawer = true;
    },
    async fetchList(pagination) {
      this.loading = true;
      await this.fetchListAction({ page: pagination, search: '' });
      this.loading = false;
    }
  },
  computed: {
    ...mapGetters({
      goalDistribuitionList: 'goalsDistribuition/goalDistribuitionList',
      getEspecificDistribution: 'goalsDistribuition/getEspecificDistribution',
      paginationGetter: 'goalsDistribuition/pagination'
    }),
    distributionList() {
      return this.goalDistribuitionList.data || [];
    },
    specificRoles() {
      return (this.fetchEspecificRoles
          && this.fetchEspecificRoles.map(role => ({
            id: role.id,
            slug: role.slug
          }))
      ) || [];
    },
    length() {
      return this.paginationDistribuition && this.paginationDistribuition.last_page;
    },
    currentPage() {
      return this.paginationDistribuition && this.paginationDistribuition.current_page;
    }
  },
  watch: {
    pagination(page) {
      this.fetchList(page);
    }
  },
  async beforeMount() {
    await this.fetchList(this.pagination);
    this.roles = this.specificRoles;
  }
};
</script>

<style lang="scss">
.search-input .smart-input.rounded.w-full {
  padding-left: 35px;
}

.switch-right {
  right: 2rem;
  height: 25px;
}
.width-status {
  min-width: 160px;
}
.width-cnpj {
  min-width: 166px;
}

.products-style {
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
